/**
 * Common utility functions
 * Provides UUID generation, JSON parsing, money formatting, proper casing, and global state access
 */

import { v4 as uuidv4 } from 'uuid'
import { formatMoney as shopifyFormatMoney } from './currency-formatter'

function generateID() {
  return uuidv4()
}

function parseJSON(input: string | object, defaultReturnType = 'object') {
  if (typeof input === 'object') return input
  if (!input) return defaultReturnType === 'object' ? {} : []
  try {
    return JSON.parse(input.replace(/(&quot;)/g, '"'))
  } catch (err) {
    console.error('Could not parse input in parseJSON.', parseJSON, err)
    return defaultReturnType === 'object' ? {} : []
  }
}

/**
 * Converts an all-caps (or mixed-case) string to proper case, capitalising the first
 * letter of every word. Option values arrive uppercase from the PIM, and slash-joined
 * colourways need each part capitalised: `IVORY/MULTI` -> `Ivory/Multi`.
 */
function toProperCase(value: string) {
  if (!value) return value
  return value.toLowerCase().replace(/(^|[\s/&-])([a-z])/g, (_match, separator, letter) => separator + letter.toUpperCase())
}

const globalState = window.globals
const formatMoney = function (cents: number | string, format = globalState.shopify.moneyFormat) {
  return shopifyFormatMoney(cents, format)
}

/** Flattens a Shopify rich_text_field JSON node into plain text. */
const extractTextContent = (node: any): string => {
  if (!node) return ''
  if (typeof node === 'string') return node
  if (Array.isArray(node)) return node.map(extractTextContent).join('')
  if (typeof node === 'object') {
    if (typeof node.value === 'string') return node.value
    if (Array.isArray(node.children)) return node.children.map(extractTextContent).join('')
  }
  return ''
}

export {
  formatMoney,
  globalState,
  parseJSON,
  generateID,
  toProperCase,
  extractTextContent
}
